import { definirAppDeclaree } from '@taki/app-runtime';
import appInfo from './taki.app.json';
import champs from './taki.fields.json';
import ecrans from './taki.screens.json';
import { importDemoDataset } from './demo-dataset.js';

export const catalogueApp = definirAppDeclaree({
  fiche: appInfo,
  champs,
  ecrans,
  demo: {
    ecrit: [
      { family: 'products', type: 'article' }, { family: 'products', type: 'protocole' },
      { family: 'compositions', type: 'ligne' }, { family: 'policies', type: 'calcul' },
      { family: 'policies', type: 'posologie' },
    ],
    importer: ({ sdk, orgId }) => importDemoDataset(sdk, orgId),
  },
});
export default catalogueApp;
